import React from 'react';
import { ResourcesTemplate } from '../../_templates/ResourcesTemplate';

export const Resources = () => {
  return (
    <ResourcesTemplate />
  );
};